module.exports = __webpack_public_path__ + "static/img/7.16c617b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/7.png
// module id = ChgR
// module chunks = 0